import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "TIPS Bengaluru | The Indian Public School";
const BASE_URL = "https://tips-bengaluru.org";
const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/fcc543bd-d42f-4ba5-bf4e-a8bc67b4a41b/images/de05625decb0b8b65cf662a6ed27ada0d7f575706f16a0d41c94b221dd2dac5e.jpeg";

const SEO = ({ title, description, keywords, canonical }) => {
  const fullTitle = title ? `${title} | TIPS Bengaluru` : SITE_NAME;
  const metaDesc = description ||
    "The Indian Public School (TIPS) Bengaluru – Premier CBSE school across 6 campuses in Bangalore. Admissions open 2026–27 for Nursery to Grade XII. Enquire now.";
  const metaKeywords = keywords ||
    "TIPS Bengaluru, The Indian Public School Bengaluru, CBSE school Bangalore, best CBSE school Bangalore, TIPS school admissions, school admissions Bangalore 2026, CBSE school HBR Layout, school near Nagawara Bangalore, top schools in Bangalore, TIPS CBSE school fees, school admissions 2026-27 Bangalore, CBSE affiliated school Bangalore";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content="The Indian Public School, Bengaluru" />
      <meta name="robots" content="index, follow" />
      {canonical && <link rel="canonical" href={`${BASE_URL}${canonical}`} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TIPS Bengaluru" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={OG_IMAGE} />
      {canonical && <meta property="og:url" content={`${BASE_URL}${canonical}`} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {/* Schema.org structured data */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "School",
        "name": "The Indian Public School, Bengaluru",
        "url": "https://tips-bengaluru.org",
        "logo": OG_IMAGE,
        "description": "CBSE affiliated school with 6 campuses across Bengaluru. Nursery to Grade XII.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "78/4/1, Vidya Nidhi, Opposite Manyata Tech Park Gate-1, HBR Layout",
          "addressLocality": "Bengaluru",
          "addressRegion": "Karnataka",
          "postalCode": "560045",
          "addressCountry": "IN"
        },
        "telephone": "+917619305034",
        "email": "infobengaluru@tipsmail.net",
        "sameAs": ["https://tips-bengaluru.org"]
      })}</script>
    </Helmet>
  );
};

export default SEO;
